
    import '/home/runner/work/GPT-Vis/GPT-Vis/src/Map/index.md?watch=parent';
    export const demoIndex = {
  ids: ["map-demo-0"],
  getter: () => import(/* webpackChunkName: "meta__Map" */'/home/runner/work/GPT-Vis/GPT-Vis/src/Map/index.md?type=demo')
};